import { render, staticRenderFns } from "./arrow.vue?vue&type=template&id=ccb36618&"
import script from "./arrow.vue?vue&type=script&lang=js&"
export * from "./arrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccb36618')) {
      api.createRecord('ccb36618', component.options)
    } else {
      api.reload('ccb36618', component.options)
    }
    module.hot.accept("./arrow.vue?vue&type=template&id=ccb36618&", function () {
      api.rerender('ccb36618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/arrow.vue"
export default component.exports